const Z_INDEX = {
  NAV_OPEN: 5000,
}

export default Z_INDEX
